<template>
  <div class="business">
    <div class="title">
      <div class="title-logo"></div>
      <div class="title-right">
        <div class="menu">
          <nx-nav />
        </div>
        <div class="title-user">
          <user-info v-if="!ifLogin"></user-info>
          <login-user v-if="ifLogin" class="tc"></login-user>
        </div>
      </div>
    </div>
    
    <div class="info-wrap">
      <div class="loading" v-if="loadingShow === true">
        <div class="loadingImg"></div>
      </div>
      <div class="info-table">
        <div class="switchSite">
          <span class="nxsite insite" @click="clearNews()">全部已读</span>
        </div>
        <div class="newBox">
          <div class="newTitle">
            <span>时间</span>
            <span>标题</span>
            <span class="nr">内容</span>
            <span>操作</span>
          </div>
          <div class="content" v-for="(item,index) in newsArray" :key="index">
            <span>{{ item.time }}</span>
            <span>{{ item.title }}</span>
            <span class="nr">{{ item.content }}</span>
            <span v-if="item.isread == 'false'"><span class="readNews" @click="readNews(index)">未读</span></span>
            <span v-if="item.isread == 'true'" class="noread">已读</span>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev,pager,next"
      :page-size="pageCount"
      :total="$store.state.news.length"
      @current-change="handleCurrentChange"
      :current-page="pageNum" 
    ></el-pagination>
    <!-- <div class="info-page">
      <el-pagination background layout="prev,pager,next" :page-size="pageCount" :total="staff.length" @current-change="handleCurrentChange"></el-pagination>
    </div>-->
    <tabBottom></tabBottom>
  </div>
</template>

<script>
import NxNav from "../NxNav";
import UserInfo from "../user";
import tabBottom from "../tabBottom";
import isPlus from "@/js/isPlus";
import loginUser from "../user2";
export default {
  components: {
    NxNav,
    UserInfo,
    tabBottom,
    loginUser
  },
  data() {
    return {
      staff: [],
      loadingShow: false,
      pageNum: 1,
      pageCount: 10,
      newsArray: []
    };
  },
  mounted() {
    var me = this;
    this.loadingShow = true;
    var hide
    clearTimeout(hide)
    //阻止冒泡事件
    document.addEventListener("click", e => {
      if (e.target.className != "userData") {
        this.actUser = false;
      }
    });
    if (!me.ifLogin) {
      setTimeout(function() {
        me.loadingShow = false;
        me.$router.push({ path: "/web" });
      }, 500);
    }
    me.getNews()
    hide = setTimeout(function() {
      me.loadingShow = false;
    }, 10000);
  },
  sockets: {
    connect: function() {
      var token = localStorage.getItem("jwt");
      if (token) {
        this.$socket.emit("authenticate", { token });
      }
    },
    authenticated: function(data) {
      var token = localStorage.getItem("jwt");

      this.$socket.emit("queryUser", token);
    },
    unauthorized: function(error) {
      console.log('unauthorizederror :>> ', error );
      if (error.message === 'jwt expired') {
        this.$router.push({ path: "/" });
      }
    },
    getNews: function(data) {
      if (data.data){
        this.$store.state.news = data.data
      }
      if (data.noRead){
        this.$store.state.badge = data.noRead
      }
      if (isPlus && window.plus && data.noRead) {
        plus.runtime.setBadgeNumber(data.noRead);
      }
      this.pageInit()
      this.loadingShow = false;
    },
    setNews: function(data) {
      if(data.state){
        this.$store.state.news[data.index].isread = 'true'
        var item = this.$store.state.news[data.index]
        this.$store.state.news.splice(data.index, 1)
        this.$store.state.news.push(item)
        this.$store.state.badge = this.$store.state.badge-1;
        if (isPlus && window.plus) {
          plus.runtime.setBadgeNumber(this.$store.state.badge-1);
        }
        this.pageInit()
      }
    },
    clearNews: function(data) {
      this.$store.state.news.forEach(item => {
        item.isread = 'true'
      });
      this.$store.state.badge = 0
      if (isPlus && window.plus) {
        plus.runtime.setBadgeNumber(0);
      }
      this.pageInit()
    },
  },
  methods: {
    authenticate() {
      var token = localStorage.getItem("jwt");
      if (token) {
        this.$socket.emit("authenticate", { token });
      }
    },
    getNews:function(){
      var type,data
      var me = this
      if (me.$store.state.userName) {
        type = 'userName'
        data = me.$store.state.userName
      } else if (me.$store.state.wxAppData){
        type = 'unionid'
        data = me.$store.state.wxAppData
      }
      me.$socket.emit('getNews',{
        type: type,
        data: data
      })
    },
    readNews:function(rows){
      var me = this
      me.$socket.emit('setNews',{
        id: me.$store.state.news[rows].id,
        index: rows
      })
    },
    clearNews: function() {
      var me = this
      var type,data
      if (me.$store.state.userName) {
        type = 'userName'
        data = me.$store.state.userName
      } else if (me.$store.state.wxAppData){
        type = 'unionid'
        data = me.$store.state.wxAppData
      }
      me.$socket.emit('clearNews',{
        type: type,
        data: data
      })
    },
    handleCurrentChange(val) {
      var me = this;
      me.pageNum = val;
      me.pageInit();
    },
    pageInit(){
      this.newsArray = this.$store.state.news.slice(
        (this.pageNum - 1) * this.pageCount,
        this.pageNum * this.pageCount
      );
      this.newsArray.map(i => {
        var index = i.content.indexOf('：')
        i.content = i.content.slice(index + 1)
      })
    }
  },
  computed: {
    ifLogin() {
      return this.$store.state.ifLogin;
    },
  }
};
</script>

<style lang="less" scoped>
.business {
  position: relative;
  padding-bottom: 20px;
  .tc {
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    float: right;
    width: 200px;
  }
  .info-wrap {
    display: flex;
    margin: 0 auto;
    width: 70vw;
    height: 80vh;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 70px;
    margin-bottom: 30px;
    .loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      background-color: #181e26;
      .loadingImg {
        width: 320px;
        height: 240px;
        background-image: url(../../assets/loading.gif);
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        line-height: 420px;
        color: #21a2f5;
        font-size: 18px;
      }
    }
    .switchSite {
        width: 100%;
        height: 40px;
        margin: 3% 0;
        align-self: center;
        line-height: 40px;
        text-align: left;
        font-size: 12px;
        span {
          height: 30px;
          line-height: 25px;
          display: inline-block;
          cursor: pointer;
          border: 1px solid rgb(148, 146, 146);
          padding: 2px 5px;
          margin-right: 5%;
          border-radius: 10px;
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
            0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
        }
        .insite{
          color: rgb(33, 162, 245);
        }
      }
    .info-top {
      color: #fff;
      display: flex;
      width: 100%;
      height: 10vh;
      justify-content: center;
      align-items: center;
      .info-top-title {
        color: #fff;
        font-size: 14px;
        text-align: left;
        height: 3vh;
        margin: 2vh 1vw;
        font-weight: 350;
      }
    }
    .info-table {
      font-size: 14px;
      text-align: left;
      // background-color: #20252f;
      padding: 0.5vw 1.8vw 0.5vw 1vw;
      // overflow: hidden;
      width: 100%;
      height: 100%;
      margin-bottom: 50px;
      margin:auto;
      p{
        color:#fff;
        font-size: 18px;
        a{
          text-decoration: none;
          color:cornflowerblue;
        }
      }
      .noTitle{
        width: 90vw;
        text-align: center;
      }
      .newBox {
        background-color: #20252f;
        border-radius: 10px;
        font-size: 12px;
        color: #fff;
        box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
        .newTitle {
          height: 45px;
          line-height: 45px;
          span {
            width: 20%;
            padding-left: 10px;
            display: inline-block;
          }
          .nr {
            width: 38%;
          }
        }
        .content {
          height: 45px;
          line-height: 45px;
          border-top: 1px solid #666;
          >span {
            width: 20%;
            padding-left: 10px;
            display: inline-block;
          }
          .nr {
            width: 38%;
          }
          .readNews {
            color: #4f86ed;
            cursor: pointer;
          }
          .noread {
            color: #666;
          }
        }
      }
    }
  }
  .el-pagination{
    padding: 25px 5px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pc/PCNews.vue